/**
 * 화면ID : COMCDD001_00FP
 * ASIS : 인터넷뱅킹 H03501.jsp
 */
import { Trans, useTranslation } from 'react-i18next';
import { Modules, PropsWithPopup, useConfig } from 'scbk-services';
import { CarbonFree, DialogWrapper } from 'scbk-ui-web';
import { QRCodeSVG } from 'qrcode.react';

interface Props extends PropsWithPopup {
  onComplete?: () => void;
  onClose?: () => void;
}

const CddQRPopupComponent: React.FC<Props> = ({ isOpen, setOpen, onComplete, onClose }) => {
  // 다국어 처리
  const { t } = useTranslation();
  const { getConfig } = useConfig();
  const ma30Domain = getConfig(Modules.COMMON).ma30Domain;

  return (
    <DialogWrapper
      title={t('Cdd.006', {
        defaultValue: '고객확인제도 안내',
      })}
      isFull
      open={isOpen}
      setOpen={setOpen}
      onClose={() => {
        onClose?.();
      }}
      footer={[
        {
          type: 'primary',
          title: t('Cdd.005', {
            defaultValue: '확인',
          }),
          handler: () => {
            onComplete?.();
          },
          hasClose: true,
        },
      ]}
    >
      <div className="flex flex-col items-center text-center">
        <CarbonFree />
        <div className="mx-auto">
          <h2 className="page-heading-title mt-2 mb-3">
            {t('Cdd.007', {
              defaultValue:
                '[특정 금융거래정보의 보고 및 이용 등에 관한 법률」 제5조의2(금융회사 등의 고객확인의무)]에 따라 고객확인업무가 필요해요',
            })}
          </h2>
          <p className="page-desc-lg mb-3">
            <Trans t={t} i18nKey="Cdd.009" components={[<br />]} />
          </p>
          <p className="page-desc-lg mb-4">
            <Trans i18nKey="Cdd.019" components={[<span className="inline md:block mr-1"></span>]}>
              <span className="block md:inline md:mr-1">
                다음의 QR코드를 스캔하거나 모바일뱅킹에서
              </span>
              고객정보 확인을 진행해 주세요
            </Trans>
          </p>
        </div>
        <QRCodeSVG
          role="img"
          aria-label={t('Cdd.021', {
            defaultValue: '모바일뱅킹 고객정보 확인 진행 안내 qr 이미지',
          })}
          value={`${ma30Domain}/custcenter/MA3CSTCDD001.mnu`}
          className="w-[88px] h-[88px]"
        />
      </div>
    </DialogWrapper>
  );
};

export default CddQRPopupComponent;
